const getCheckNavImagesFlag = (state) => {
  return state?.Navigation?.checkNavImagesFlag;
};

export const getAccountDrawerOpen = (state) => {
  return state?.Header?.accountDrawerOpen;
};

export default getCheckNavImagesFlag;
